export default "__VITE_ASSET__DeiuMjXg__"